import type { EntityValidationRules } from "../services/validationService";

export default class Policy {
  requiredLength: number;
  requiredUniqueChars: number;
  requireNonAlphanumeric: boolean;
  requireLowercase: boolean;
  requireUppercase: boolean;
  requireDigit: boolean;
}

export const PasswordPolicyValidationRules: EntityValidationRules<Policy> = {
  requiredLength: {
    isInteger: true,
    range: {
      min: 1,
      max: 30,
    },
  },
  requiredUniqueChars: {
    isInteger: true,
    range: {
      min: 1,
      max: (entity: Policy) => (entity.requiredLength > 1 ? entity.requiredLength : undefined),
    },
  },
};
